<template>
    <v-container class="my-0 pt-1 pb-0 px-0">
        <v-row no-gutters v-if="loading" class="pa-2 ma-0">
            <v-progress-circular
                    indeterminate
                    size="64"
                    width="7"
                    color="primary"
                    ></v-progress-circular>
        </v-row>
        <v-row no-gutters v-else class="flex-row" pa-0 ma-0 >
            <v-col cols="12" sm="12" md="3" class="d-flex align-start justify-end order-xs-1 order-sm-1 order-md-2 pb-0">
                <slot name="other_action"></slot>
                <span v-can="{obj_type:'organism', action: 'edit'}" v-if="can_change">
                <v-btn v-can="{obj_type:'primary', action: 'edit'}" color="primary" @click.stop="editInstrument" fab small><v-icon class="pa-2" small>create</v-icon></v-btn>
                <v-btn v-can="{obj_type:'primary', action: 'edit'}" color="primary" @click.stop="cloneInstrument" fab small><v-icon class="pa-2" small>file_copy</v-icon></v-btn>
                <v-btn v-can="{obj_type:'primary', action: 'remove'}" color="primary" @click.stop="openDeleteInstrumentConfirm" fab small><v-icon class="pa-2" small>delete</v-icon></v-btn>
                </span>
            </v-col>
            <v-col cols="12" sm="12" md="9" class="d-flex align-start justify-start order-xs-2 order-sm-2 order-md-1 pb-1 cursor_pointer" @click.stop.prevent="itemDetails">
                <div width="100%" class="d-flex flex-grow-1 flex-shrink-0 align-start justify-center fill-height">
                    <div class="d-flex flex-shrink-1 flex-grow-0 pr-1">
                      <StatusIcon :status="iconStatus.instrument" :tooltip_text="instr_tooltip[iconStatus.instrument]" />
                    </div>
                    <div class="d-flex flex-column flex-grow-1 flex-shrink-0 text-left">
                        <div class="d-flex flex-row">
                            <span v-if="instrument.name!=''" class="font-italic d-flex flex-grow-1 flex-shrink-0"><b >{{ instrument.name }} </b></span>
                            <span v-else class="font-italic d-flex flex-grow-1 flex-shrink-0"><b>{{ instrument.serno}}</b> - <b>{{ instrument.model }}</b> - <b>{{ instrument.manufacturer}}</b></span>
                            <i class="d-flex flex-grow-0 flex-shrink-1">{{ instrument.family }}</i>
                        </div>
                        <div class="d-flex flex-grow-1 flex-shrink-0">
                            <div class="d-flex flex-column flex-grow-1 flex-shrink-0">
                                <div v-if="!!organization">Proprietà: <b>{{ organization.value.name }}</b></div>
                                <div v-if="!!used_by">Utilizzato da: <i v-for="(item, idx) of used_by" :key="item._id">{{ item.value.name }} <span v-if="idx!=(used_by.length-1)">, </span></i></div>
                                <div>Certificato n°: <span class="font-weight-bold">{{instrument.primary_data.certificate_nr}}</span>, emesso da <span class="font-weight-bold">{{instrument.primary_data.certificate_authority}}</span> il <span class="font-weight-bold">{{instrument.primary_data.emission | formatDateTS }}</span><br/>
                                Scadenza: <span class="font-weight-bold">{{instrument.primary_data.expire | formatDateTS }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </v-col>
        </v-row>
        <ConfirmDialog
            v-bind:data="delete_confirm"
            v-on:close_dialog="closeDialog"
            v-on:confirm_result="onDeleteConfirm"/>
        <InstrumentDialog
            ref="instrumentEdit"
            v-on:update_instrument="updateInstrument"
        />
    </v-container>
</template>
<script>
// import _ from 'lodash'

import ConfirmDialog from '../../components/dialogs/ConfirmDialog'
import StatusIcon from '../../components/utils/StatusIcon'
import InstrumentDialog from "./InstrumentDialog"
import { getObjStatus } from '../../utils/commonUtils'
import { i_families, instrument_status_tooltip } from "../../utils/common.js"
 

export default {
    components: {ConfirmDialog, InstrumentDialog, StatusIcon},
    props: {
        instrument_id: {
            type: String,
            required: true
        },
        show_org: {
            type: Boolean,
            required: false,
            default: true
        },
        show_used: {
            type: Boolean,
            required: false,
            default: true
        },
        enable_clone: {
            type: Boolean,
            required: false,
            default: true
        },
        can_change: {
            type: Boolean,
            required: false,
            default: true
        },
        disable_link: {
            type: Boolean,
            required: false,
            default: false
        },
        lock_client: {
            type: Boolean,
            required: false,
            default: false
        },
        organizations: {
            type: Object,
            required: true
        },
        deletable: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    data(){
        return {
            delete_confirm: {
                dialog: false,
                doc: null,
                title: 'Elimina strumento',
                message: "Sei sicuro di voler rimuovere lo strumento selezionato?",
                choices: [
                    {key: "cancel", val: "annulla", mod: "success"},
                    {key: "delete", val: "elimina"}
                    ]
            },
            loading: true,
            instrument: null,
            iconStatus: {},
            used_by: [],
            instr_tooltip: instrument_status_tooltip
        }
    },
    computed: {
        
    },
    async mounted() {
        await this.loadInstrument()
    },
    methods: {
         openDeleteInstrumentConfirm(){
            console.log('DELETE')
            this.delete_confirm.message = "Sei sicuro di voler archiviare <br/><b>" + this.instrument.name+" / "+ this.instrument.serno+" - "+this.instrument.manufacturer+" - "+this.instrument.model+"</b>?"
            this.delete_confirm.dialog = true;
        },
        async onDeleteConfirm(choice){
            try {
                if(choice == "delete"){
                    this.instrument.updated_by = this.$store.state.user._id
                    this.instrument.updated = (new Date()).getTime()
                    this.instrument.dismissed = true
                    let res = await this.$store.state.$pouch.put('registry', this.instrument)
                    if (res.ok) {
                        this.instrument._rev = res.rev
                        this.$emit('primary_removed', this.instrument._id)
                    }
                } 
                this.closeDialog()
            } catch(error) {
                console.log('error', error)
            }
        },


        closeDialog(){
            this.delete_confirm.dialog = false;
        },

        itemDetails(){
            console.log("******************", this.$router.history, this.$router.history.current)

            if (this.disable_link) return
            if (this.instrument.primary) {
                this.$router.push({path: "/admin/primaries/primaryDetails", query: {i_id: this.instrument_id, back: this.$router.history.current.fullPath}})
            }
        },
        editInstrument(){
            this.$refs.instrumentEdit.openDialog({instrument_id: this.instrument_id, 
                lock_client: this.lock_client, 
                primary: this.instrument.primary,
                org_id: this.instrument.org_id});
        },
        cloneInstrument(){
            this.$refs.instrumentEdit.openDialog({instrument_id: this.instrument_id, lock_client: this.lock_client, clone: true, 
                primary: this.instrument.primary,
                org_id: this.instrument.org_id});
        },
        updateInstrument(instr_id) {
            if (instr_id == this.instrument_id) {
                // UPDATE INSTRUMENT
                this.loadInstrument()
                this.$emit('update_instrument', instr_id)
            } else {
                // CLONE INSTRUMENT
                this.$emit('add_instrument', instr_id)
            }
        },
        async loadInstrument() {
            this.loading = true
            console.log('LOAD INSTRUMENT')
            this.instrument = await this.$store.state.$pouch.get('registry', this.instrument_id)
            if (this.show_org) {
                this.organization = this.organizations[this.instrument.org_id]
            }
            if (this.show_used) {
                if (typeof this.instrument.used_by === "string") {
                    this.used_by = [this.organizations[this.instrument.used_by]]
                } else {
                    for (let o_id in this.instrument.used_by) {
                        console.log('§§§§§', o_id)
                        this.used_by.push(this.organizations[o_id])
                    }
                }
                
            }
            
            this.getStatusIcon()
            this.loading = false
        },
        getStatusIcon() {
            let data = {expire_status: true}
            if (!this.instrument.primary) {
                data.allowed_report = Object.keys(i_families[this.instrument.family].report)
            }
            this.iconStatus = getObjStatus(this.$store.state.config.threshold, this.instrument, data)
            //console.log("**** STATUS", this.iconStatus)
        },
    },
    
    
}

</script>